import { useState } from "react";
import useModuleData from "./useFetchItems";
import { MODULE_API } from "../../../../apis";
import swal from "sweetalert"; 

export default function useDeleteItem(fetchData, formatModuleKey, setTableData, setLoading) {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const deleteRecord = async (record) => {
    if (!record.id || !record.module) {
      setError(new Error("Invalid record data provided for deletion"));
      return false;
    }
    const willDelete = await swal({
      title: "Are you sure?",
      text: "You want to delete this item.",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, delete it!"],
      dangerMode: true,
    });
  
    if (!willDelete) {
      swal("Cancelled", "Your item is safe :)", "info");
      return;
    }

    try {
      setLoading(true);
      setError(null);
      setSuccess(false);
      setTableData((prev) => {
        const moduleKey = formatModuleKey(record.module);
        return {
          ...prev,
          [moduleKey]: (prev[moduleKey] || []).filter((item) => item.id !== record.id),
        };
      });

      // Delete the record
      const resss = await MODULE_API.deleteItem({
        clientModules: [record.id],
      });
      if (["Investment", "Physical"].includes(record.subType)) {
        const res = await fetchData("Asset");
        setTableData((prev) => ({
          ...prev,
          [formatModuleKey("Asset")]: res.records || [],
        }));
      } else {
        const res = await fetchData(record.subType);
        setTableData((prev) => ({
          ...prev,
          [formatModuleKey(record.subType)]: res.records || [],
        }));
      }

      // Refresh the data
      const res = await fetchData(record.module);
      console.log("deleting", res && res.records);

      // Update the table data
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(record.module)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setSuccess(true);
    } catch (error) {
      console.error("Failed to delete record:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetState = () => {
    setLoading(false);
    setError(null);
    setSuccess(false);
  };

  return {
    deleteRecord,
    error,
    success,
    resetState,
  };
}
